/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 12.03.13, 13:22
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

export class InternalGGSTextFieldConfigVO {
    public unRegisterAutomaticallyOnRemovedFromStage: boolean;

    constructor(unRegisterAutomaticallyOnRemovedFromStage: boolean) {
        this.unRegisterAutomaticallyOnRemovedFromStage = unRegisterAutomaticallyOnRemovedFromStage;
    }
}
